import { useTranslation } from 'react-i18next'
import { CurecallInput, LinkIcon } from '@honestica/curecall-ui'
import { useFormContext } from 'react-hook-form'
import { useEffect, useState } from 'react'
import { TAddContentFormValues, TUpdateContentFormValues } from './content-forms.component'

function ExternalLinkField({ currentContentName }: { currentContentName: 'content.fr' | 'content.en' }) {
  const { t } = useTranslation()
  const {
    setValue,
    clearErrors,
    getValues,
    register,
    formState: { errors },
  } = useFormContext<TAddContentFormValues | TUpdateContentFormValues>()

  const [currentLink, setCurrentLink] = useState<string>('')

  useEffect(() => {
    if (currentContentName) {
      const contentValue = getValues(currentContentName)
      setCurrentLink(contentValue || '')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentContentName])

  const onChangeLink = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newLink = event.target.value
    setCurrentLink(newLink)
    setValue(currentContentName as any, newLink)
    clearErrors('content')
  }

  return (
    <CurecallInput
      {...register('content', { required: t('pages.configuration.contents.link-required') })}
      IconLeft={<LinkIcon />}
      onChange={onChangeLink}
      label={t('pages.configuration.contents.link')}
      value={currentLink}
      name={currentContentName}
      placeholder={t('pages.configuration.contents.link-placeholder')}
      errorMessage={errors.content?.message}
      isRequired={true}
      wrapperClassName="c-mt-10"
    />
  )
}

export { ExternalLinkField }
